import * as $ from "jquery";
import {$body} from 'Core/Body';
import {getCurrentLanguage} from 'Core/Languages';
import {Notifications} from 'Core/Notifications';
import {setFormSerialized} from 'Components/Cart/GuestModal';
import {setEmail} from 'Components/Cart/GuestModal';
import {GuestModal} from 'Components/Cart/GuestModal';
import {CartCalc} from 'Components/Cart/CartCalc';
import {Step2Selectors} from 'Components/Cart/Step2/Step2Selectors';
import "bootstrap/js/src/modal";
import * as select2 from "select2";

import Step2FormValidation from "Components/Validation/Step2FormValidation";
import CreateAccountInsideCartFormValidation from "Components/Validation/CreateAccountInsideCartFormValidation";
import {Contractor, RandProductsResponse} from "Components/Cart/types";
import {isNipPl} from "../../../Functions/isNipPl";
import LoginFields from "Components/Fields/LoginFields";
const empty = require('is-empty');

export const Step2Component = (() => {
    // @ts-ignore - HACK: types mismatch the module resolution. We need to actually init select2 this way in order to be able to call $().select2() later
    select2();

    const {
        COMMON, DELIVERY_FORM_FIELDS,
        FORM_FIELDS_ERROR, DEPARTMENTS, INVOICE
    } = Step2Selectors;

    const DeliveryInput = $(COMMON.DELIVERY).find('input');
    const PaymentInput = $(COMMON.PAYMENT).find('input');
    const CollectionInPersonDeliveryMethodID: number = 19;
    const lang: string = getCurrentLanguage;

	//this variable stores information about whether the currently selected payment method is a credit
	let isSelectCreditPaymentMethod = false;

    function showGuestModal() {
        $(COMMON.GUEST_MODAL).modal("show");
        $(COMMON.ALLOW_GUEST_CHECKER).val("true");
        $("select").select2();
    }

	function showNewAccountModal(){
		$(COMMON.NEW_ACCOUNT_MODAL).modal("show");
	}

    function showDepartmentModal() {
        $(DEPARTMENTS.MODAL_SELECT).select2({
            dropdownParent: $("#DepartmentsModal")
        });
        if ($(COMMON.SELECTED_DELIVERY_RADIO).val() == 19) {
            $(DEPARTMENTS.MODAL).modal("show");
            $(DEPARTMENTS.ADDRESS_DIV).show();
            $(DEPARTMENTS.ID_INPUT).data('rule-required', true);
        } else  {
            $(DEPARTMENTS.ADDRESS_DIV).hide();
            $(DEPARTMENTS.ID_INPUT).val('');
            $(DEPARTMENTS.ID_INPUT).data('rule-required', false);
            $(DEPARTMENTS.ADDRESS).html('Brak salonu');
        }
    }

    function changeMapVoivodeship(event) {
        event.preventDefault();
        let $voivodeshipName = $(this).data('map-voivodeship');
        changeDepartmentVoivodeship($voivodeshipName);
    }

    function clickMapVoivodeshipListElement() {
        let $idDepartment = $(this).data('id-department');
        let $voivodeshipName = $(this).closest('.element-voivodeship').data('voivodeship');
        changeDepartmentVoivodeship($voivodeshipName);

        $(DEPARTMENTS.MAP_VOIVODESHIP_LIST_ELEM).removeClass('active');
        $(this).addClass('active');

        $(DEPARTMENTS.MODAL_SELECT).val($idDepartment).trigger('change');
    }

    function changeDepartmentSelect() {
        let $idDepartment = $(this).val();
        let $voivodeshipName = $(DEPARTMENTS.MAP_VOIVODESHIP_LIST).find("div[data-id-department='" + $idDepartment + "']").closest('.element-voivodeship').data('voivodeship');
        changeDepartmentVoivodeship($voivodeshipName);

        $(DEPARTMENTS.MAP_VOIVODESHIP_LIST_ELEM).removeClass('active');
        $(DEPARTMENTS.MAP_VOIVODESHIP_LIST).find('div[data-id-department="' + $idDepartment + '"]').addClass('active');

        $(DEPARTMENTS.MODAL_SELECT).val($idDepartment).trigger('change');
    }

    function changeDepartmentVoivodeship($voivodeshipName) {
        $(DEPARTMENTS.MAP_VOIVODESHIP).removeClass('active');
        $(DEPARTMENTS.MAP_VOIVODESHIP).find('path').removeClass('active');

        $(DEPARTMENTS.MAP_VOIVODESHIP + '[data-map-voivodeship=' + $voivodeshipName + ']').addClass('active');
        $(DEPARTMENTS.MAP_VOIVODESHIP + '[data-map-voivodeship=' + $voivodeshipName + ']').find('path').addClass('active');

        $(DEPARTMENTS.MAP_VOIVODESHIP_LIST).find("div[data-voivodeship!='" + $voivodeshipName + "']").hide();
        $(DEPARTMENTS.MAP_VOIVODESHIP_LIST).find("div[data-voivodeship='" + $voivodeshipName + "']").show();

        $(DEPARTMENTS.MAP_VOIVODESHIP_LIST).find("div[data-voivodeship!='" + $voivodeshipName + "'] div").hide();
        $(DEPARTMENTS.MAP_VOIVODESHIP_LIST).find("div[data-voivodeship='" + $voivodeshipName + "'] div").show();

        $('#department-map-list').find('#info-before-select').hide();
    }

    function submitModalForm(event) {
        event.preventDefault();
        const lang = getCurrentLanguage;
        let $redirectUrl = $(COMMON.MODAL_FORM).find('#login_redirect_url').val();

        $.post(`/${lang}/login/sign-in/?check=1`, $(COMMON.MODAL_FORM).serialize(), (res) => {
            const json = JSON.parse(res);
            if (json.status === "success") {
                window.location.replace($redirectUrl.toString());
            } else {
                Notifications.add('Hasło jest nieprawidłowe', 'error');
            }
        });
        return false;
    }

    function submitDepartmentForm(event) {
        event.preventDefault();

        const $idDepartment = $(DEPARTMENTS.MODAL_SELECT).find('option:selected').val();
        const $addressDepartment = $(DEPARTMENTS.MODAL_SELECT).find('option:selected').text();

        $(DEPARTMENTS.MODAL).modal("hide");
        if ($idDepartment) {
            $(DEPARTMENTS.ADDRESS_DIV).show();
            $(FORM_FIELDS_ERROR.ID_INPUT).css({"display": "none"});
            $(DEPARTMENTS.ADDRESS).html($addressDepartment);
            $(DEPARTMENTS.ID_INPUT).val($idDepartment);
            $(DEPARTMENTS.ADDRESS_DIV).removeClass('is-invalid');
            $(DEPARTMENTS.ADDRESS_DIV_ERROR_VALIDATE).css({"display": "none"});
        } else {
            $(FORM_FIELDS_ERROR.ID_INPUT).css({"display": "block"});
            $(DEPARTMENTS.ADDRESS).html('Brak salonu');
            $(DEPARTMENTS.ID_INPUT).val('');
        }
    }

    function checkIfGuestExistsAndShowModalIfYes(e: JQueryEventObject) {
        e.preventDefault()
		let step2FormValidation = new Step2FormValidation();
		if(step2FormValidation.validate() ) {

			const email = $(COMMON.DELIVERY_EMAIL_INPUT).val() as string;
			const FormSerialized = $(COMMON.FORM).serialize();
			let isSetWantNewAccount = $(COMMON.WANT_NEW_ACCOUNT_CHECKBOX).prop('checked');

			if (email.trim()) {
				$.get(`/${lang}/cart/checkIfGuestAlreadyExists/${email}`, function (data) {
					if(data === 'NOT EXIST' && !isSetWantNewAccount){
						showNewAccountModal();
					}
					else if (data === 'EXIST' && $(COMMON.ALLOW_GUEST_CHECKER).val() != 'true') {
						setEmail(email, COMMON.MODAL_EMAIL);
						setFormSerialized(FormSerialized, COMMON.MODAL_FORM_SERIALIZED);
						showGuestModal();
					}
					else {
						submitForm();
					}
				});
			} else {
				submitForm();
			}

		}
    }

    function submitForm() {
        let step2FormValidation = new Step2FormValidation();
        if(step2FormValidation.validate() ){
            $(COMMON.LAST_STEP_BTN).prop('disabled', true);
            $(COMMON.LAST_STEP_BTN_FINAL).prop('disabled', true);
            $(COMMON.LIGHT_PRELOADER).removeClass('d-none');
            $(COMMON.FORM).submit();
        }else{
            Notifications.add(`Wystąpił błąd w wysyłaniu formularza`, 'error');
        }
    }

    function copyDeliveryDataToForm(clickedButton) {
        let formToApplyFields: string;
        let fields: string[];

        $(clickedButton).attr('id') == $(COMMON.COPY_INVOICE_BTN).attr('id')
            ? formToApplyFields = 'invoice'
            : formToApplyFields = 'another_delivery';

        formToApplyFields == 'invoice'
            ? fields = ['street', 'hnumber', 'lnumber', 'postal', 'city', 'email', 'phone']
            : fields = ['first_name', 'last_name', 'street', 'hnumber', 'lnumber', 'postal', 'city', 'phone', 'email'];


        fields.forEach(field => $(`#${formToApplyFields}_${field}`).val($(`#delivery_${field}`).val()));
    }

    function toggleInvoiceDataVisibility(e) {
        e.preventDefault();
        let wantInvoice = $(COMMON.WANT_INVOICE_CHECKBOX).prop('checked');
        if(wantInvoice){
			$(INVOICE.SECTION).addClass('d-block').removeClass('d-none');
        } else {
            $(INVOICE.SECTION).addClass('d-none').removeClass('d-block');
        }

		togglePaymentMethodBlock();
		toggleCreditAgricolePaymentMethod();
    }

    function toggleAnotherDeliveryAddressFormVisibility(e) {
        e.preventDefault();
        $(COMMON.ANOTHER_DELIVERY_ADDRESS_DATA).toggle();
        toggleDeliveryMethodBlock();
    }


    function checkIfAnotherDeliveryMethodShouldBeBlocked() {
        // Check if CollectionInPerson is the only one available delivery method: if yes => block another delivery methods checkbox
        // @ts-ignore
        const blocked: boolean = $(COMMON.DELIVERY_RADIO).length == 1 && parseInt($(COMMON.DELIVERY_RADIO).val()) == CollectionInPersonDeliveryMethodID;

        if (blocked) {
            $(COMMON.WANT_ANOTHER_DELIVERY_ADRESS_CHECKBOX).prop('disabled', true);
            $(COMMON.DELIVERY_TILE).removeClass('method-locked');
            $(COMMON.DELIVERY_RADIO).prop('checked', 'checked');
        }
    }

    function toggleDeliveryMethodBlock() {
        // Check if CollectionInPerson is the only one available delivery method
        // @ts-ignore
        if ($(COMMON.DELIVERY_TILE_SALON).hasClass('method-locked')) {
            $(COMMON.DELIVERY_TILE_SALON).removeClass('method-locked');
        } else {
            $(COMMON.DELIVERY_TILE_SALON).addClass('method-locked');
            $(COMMON.DELIVERY_RADIO_SALON).prop('checked', false);
            $(COMMON.DELIVERY_RADIO_KURIER).prop('checked', true);
            $(DEPARTMENTS.ADDRESS_DIV).css("display", "none");
        }
	}

	/**
	 * I collect all the conditions for enabling / disabling Credit Agricole payments
	 */
	function isCreditAgricolePaymentLocks() : boolean
	{
		let wantInvoice = $(COMMON.WANT_INVOICE_CHECKBOX).prop('checked');
		let bskProdsAndDeliveryPrice = $(COMMON.SUMMARY_BASKET_PRICE).attr('data-summary-delivery-price');
		let toSmallAmountInTheBasket = (parseFloat(bskProdsAndDeliveryPrice) < parseFloat($(COMMON.PAYMENT_METHOD_CREDIT_AGRICOLE_LOAN_0_20).data('minimum-order-amount')));
		// I'm moving all the conditions to one table
		let boolArray = [wantInvoice, toSmallAmountInTheBasket];
		// Reduces all logical OR conditions to one variable
		return  boolArray.reduce((acc, current) => acc || current, false);
	}

	/**
	 * Full information switching on credit agricole payments
	 */
	function toggleCreditAgricolePaymentMethod()
	{
		let turnOnCreditAgricolePaymentLock = isCreditAgricolePaymentLocks();
		if (turnOnCreditAgricolePaymentLock) {
			$(COMMON.PAYMENT_TILE_CREDIT_AGRICOLE_LOAN_3_0_10).addClass('method-locked');
			$(COMMON.PAYMENT_TILE_CREDIT_AGRICOLE_LOAN_0_20).addClass('method-locked');
			$(COMMON.PAYMENT_METHOD_CREDIT_AGRICOLE_LOAN_3_0_10).prop('checked', false);
			$(COMMON.PAYMENT_METHOD_CREDIT_AGRICOLE_LOAN_0_20).prop('checked', false);
		}else{
			$(COMMON.PAYMENT_TILE_CREDIT_AGRICOLE_LOAN_3_0_10).removeClass('method-locked').removeClass('method-locked-system');
			$(COMMON.PAYMENT_TILE_CREDIT_AGRICOLE_LOAN_0_20).removeClass('method-locked').removeClass('method-locked-system');
		}

		toggleCreditAgricoleErrorOnInvoice();
		toggleCreditAgricoleExtraInfo();
		togglePaymentMethodCreditAgricoleTexts();
	}

	function togglePaymentMethodCreditAgricoleTexts(){
		[COMMON.PAYMENT_TILE_CREDIT_AGRICOLE_LOAN_3_0_10, COMMON.PAYMENT_TILE_CREDIT_AGRICOLE_LOAN_0_20].forEach( (paymentBlock) => {
			if($(paymentBlock).is(".method-locked, .method-locked-system")){
				$(paymentBlock).find(COMMON.CREDIT_AGRICOLE_PAYMENT_TEXT_AVAILABLE).addClass('d-none').removeClass('d-inline');
				$(paymentBlock).find(COMMON.CREDIT_AGRICOLE_PAYMENT_TEXT_UNAVAILABLE).addClass('d-inline').removeClass('d-none');
			}else{
				$(paymentBlock).find(COMMON.CREDIT_AGRICOLE_PAYMENT_TEXT_AVAILABLE).addClass('d-inline').removeClass('d-none')
				$(paymentBlock).find(COMMON.CREDIT_AGRICOLE_PAYMENT_TEXT_UNAVAILABLE).addClass('d-none').removeClass('d-inline');
			}
		});
	}

	function toggleCreditAgricoleErrorOnInvoice(){
		let wantInvoice = $(COMMON.WANT_INVOICE_CHECKBOX).prop('checked');
		if(wantInvoice){
			$(COMMON.PAYMENT_ERROR_CREDIT_AGRICOLE_INVOICE).addClass('d-block').removeClass('d-none');
		}else{
			$(COMMON.PAYMENT_ERROR_CREDIT_AGRICOLE_INVOICE).addClass('d-none').removeClass('d-block');
		}
	}

	function toggleCreditAgricoleExtraInfo()
	{
		let isPaymentCreditAgricole = false;
		[COMMON.PAYMENT_METHOD_CREDIT_AGRICOLE_LOAN_3_0_10, COMMON.PAYMENT_METHOD_CREDIT_AGRICOLE_LOAN_0_20].forEach( (paymentRadioButton) => {
			if($(paymentRadioButton).prop("checked") == true) {
				isPaymentCreditAgricole = true;
			}
		});

		if(isPaymentCreditAgricole){
			$(COMMON.PAYMENT_INFO_CREDIT_AGRICOLE_WARNING).addClass('d-block').removeClass('d-none');
			$(COMMON.PAYMENT_INFO_CREDIT_AGRICOLE_LINK_PDF).addClass('d-block').removeClass('d-none');
		} else {
			$(COMMON.PAYMENT_INFO_CREDIT_AGRICOLE_WARNING).addClass('d-none').removeClass('d-block');
			$(COMMON.PAYMENT_INFO_CREDIT_AGRICOLE_LINK_PDF).addClass('d-none').removeClass('d-block');
		}
	}

	function togglePaymentMethodBlock() {
        if ($(COMMON.PAYMENT_TILE_COD).hasClass('method-locked')) {
            $(COMMON.PAYMENT_TILE_COD).removeClass('method-locked');
        } else {
            $(COMMON.PAYMENT_TILE_COD).addClass('method-locked');
            $(COMMON.PAYMENT_METHOD_COD).prop('checked', false);
            $(COMMON.PAYMENT_METHOD_PRZELEWY).prop('checked', true);
        }

        if ($(COMMON.PAYMENT_TILE_ERATY).hasClass('method-locked')) {
            $(COMMON.PAYMENT_TILE_ERATY).removeClass('method-locked');
        } else {
            $(COMMON.PAYMENT_TILE_ERATY).addClass('method-locked');
            $(COMMON.PAYMENT_METHOD_ERATY).prop('checked', false);
            $(COMMON.PAYMENT_METHOD_PRZELEWY).prop('checked', true);
        }
    }

    function changePaymentMethodToPrzelewy() {
        $(COMMON.PAYMENT_METHOD_PRZELEWY).prop('checked', true);
    }

	function paymentMethodChanges(){
		let isNowSelectedCreditPaymentMethod = $(COMMON.SELECTED_PAYMENT_RADIO).hasClass(COMMON.DELIVERY_RADIO_IS_CREDIT);

		let cartThresholdIsdActive = $(COMMON.CART_THRESHOLD.INPUT_IS_ACTIVE).val() === 'true';
		let cartThresholdIsFirstThresholdIsCrossed = $(COMMON.CART_THRESHOLD.INPUT_IS_FIRST_THRESHOLD_CROSSED).val() === 'true';

		if(cartThresholdIsdActive && cartThresholdIsFirstThresholdIsCrossed){
			if(isSelectCreditPaymentMethod == false && isNowSelectedCreditPaymentMethod == true){
				showCreditBankModal();
			}
		}

		isSelectCreditPaymentMethod = isNowSelectedCreditPaymentMethod;
	}

    function showCreditBankModal() {
		$(COMMON.CREDIT_PAYMENT_MODAL).modal({
			backdrop: 'static',
			keyboard: false
		});
    }

    function acceptCreditPaymentMethodFullCost() {
    	$(COMMON.CREDIT_PAYMENT_MODAL).modal("hide");
    }
	async function searchContractorAndPrepareForm(event) {
		let btn = event.currentTarget;
		btn.disabled = true;
		let nip = $(INVOICE.FIELD_NIP).val().toString();
		$(INVOICE.FIELD_NIP).attr('data-value', nip);

		let nextStepBtn = $(COMMON.LAST_STEP_BTN);
		nextStepBtn.prop('disabled', true);

		if(!isNipPl(nip)){
			$(INVOICE.FIELD_NIP).addClass('is-invalid');
			let formGroup = $(INVOICE.FIELD_NIP).closest('.form-group');
			let invalidFeedback = formGroup.find('.invalid-feedback');
			if (invalidFeedback.length > 0 && invalidFeedback.is(':visible')) {
				//do nothing - some error is already displayed
			} else {
				$(INVOICE.FIELD_NIP_ERROR).removeClass('d-none').addClass('d-block').text('Numer NIP jest niepoprawny ');
			}

			btn.disabled = false;
			nextStepBtn.prop('disabled', false);
			return;
		} else {
			$(INVOICE.FIELD_NIP).removeClass('is-invalid');
			$(INVOICE.FIELD_NIP_ERROR).removeClass('d-block').addClass('d-none').text('');
		}

		let erpData = await ajaxGetContractorDataByNip(nip);
		let countData = erpData.data.length;
		btn.disabled = false;
		nextStepBtn.prop('disabled', false);

		clearInvoiceForm();
		clearListWithContactors();
		toggleWrongInvoiceDataBtn(false);
		toggleVisibleContractorsListSelectedItem(false);
		toggleVisibleSubsectionCopyDataFromDeliveryToInvoice(false);

		if (countData == 0) {
			//scenario - no contractor
			toggleVisibleEmailAndPhoneOnInvoiceForm(true);
			toggleReadonlyOnInvoiceFormFields(false);
			toggleRequiredAndStartsOnInvoiceFormFields(true);
			toggleVisibleSubsectionCopyDataFromDeliveryToInvoice(true);

			toggleVisibleInvoiceForm(true);
			toggleVisibleContractorsList(false);

		}
		else if (countData == 1) {
			//scenario - only one contactor
			toggleVisibleEmailAndPhoneOnInvoiceForm(false);
			toggleReadonlyOnInvoiceFormFields(true);
			toggleRequiredAndStartsOnInvoiceFormFields(false);
			toggleWrongInvoiceDataBtn(true);

			setContractorToInvoiceForm(erpData.data[0]);
			toggleVisibleInvoiceForm(true);
			toggleVisibleContractorsList(false)
		}
		else {
			//scenario - multiple contactors
			toggleVisibleEmailAndPhoneOnInvoiceForm(false);
			toggleReadonlyOnInvoiceFormFields(true);
			toggleRequiredAndStartsOnInvoiceFormFields(false);
			toggleWrongInvoiceDataBtn(true);

			setListWithContactorsSortableMode(countData >= 5);
			prepareListWithContractors(erpData.data)
			toggleVisibleContractorsList(true);
		}
	}

	function clearInvoiceForm(){
		Object.entries(INVOICE.FORM_FIELDS).forEach(([key, value]) => {
			$(value).val('');
		});
	}

	function toggleReadonlyOnInvoiceFormFields(readonly: boolean){
		Object.entries(INVOICE.FORM_FIELDS).forEach(([key, value]) => {
			$(value).prop('readonly', readonly);
		});
	}

	function setContractorToInvoiceForm(data: Contractor){
		$(INVOICE.FORM_FIELDS.INVOICE_COMPANY_NAME).val(data.NAZWA_PELNA);
		$(INVOICE.FORM_FIELDS.INVOICE_COMPANY_STREET).val(data.ULICA);
		$(INVOICE.FORM_FIELDS.INVOICE_COMPANY_HNUMBER).val(data.NR_DOMU);
		$(INVOICE.FORM_FIELDS.INVOICE_COMPANY_LNUMBER).val(data.NR_LOKALU);
		$(INVOICE.FORM_FIELDS.INVOICE_COMPANY_POSTAL_CODE).val(data.KOD_POCZTOWY);
		$(INVOICE.FORM_FIELDS.INVOICE_COMPANY_CITY).val(data.MIEJSCOWOSC);
		$(INVOICE.FORM_FIELDS.INVOICE_CONTRACTOR_NUMBER).val(data.NUMER_KONTRAHENTA);
	}

	function selectSingleContractorFromList(event){
		let btn = event.currentTarget;

		const contractor: Contractor = {
			NUMER_KONTRAHENTA: $(this).val() as string,
			NIP: $(this).data('nip'),
			NAZWA_PELNA: $(this).data('company-name'),
			MIEJSCOWOSC: $(this).data('city'),
			KOD_POCZTOWY: $(this).data('postal-code'),
			ULICA: $(this).data('street'),
			NR_DOMU: $(this).data('fnumber'),
			NR_LOKALU: $(this).data('lnumber')
		};

		setContractorToInvoiceForm(contractor);
		setContractorToListHeader(contractor);
		toggleVisibleInvoiceForm(true);
		toggleVisibleContractorsListSelectedItem(true);
		toggleVisibleContractorsList(false);

		Object.entries([
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_NAME,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_CITY,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_POSTAL_CODE,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_STREET,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_HNUMBER,
			INVOICE.FORM_FIELDS.INVOICE_EMAIL,
			INVOICE.FORM_FIELDS.INVOICE_PHONE,
		]).forEach(([key, value]) => {
			let inputElement = $(value).removeClass("is-invalid");
			let validatorErrorElement = inputElement.closest('.form-group').find('.invalid-feedback').remove();
		});
	}

	function toggleVisibleInvoiceForm(show : boolean){
		if(show){
			$(INVOICE.FORM_SECTION).addClass('d-flex').removeClass('d-none');
		}
		else {
			$(INVOICE.FORM_SECTION).addClass('d-none').removeClass('d-flex');
		}
	}

	function toggleVisibleContractorsList(show: boolean | null) {
		const $section = $(INVOICE.CONTRACTORS_LIST.SECTION);

		if (show === null) {
			// If the show parameter is null, check the classes
			if ($section.hasClass('d-block')) {
				$section.addClass('d-none').removeClass('d-block');
			} else {
				$section.addClass('d-block').removeClass('d-none');
			}
		} else {
			// If show is true or false, act on its value
			if (show) {
				$section.addClass('d-block').removeClass('d-none');
			} else {
				$section.addClass('d-none').removeClass('d-block');
			}
		}
	}

	function toggleVisibleContractorsListSelectedItem(show : boolean){
		if(show){
			$(INVOICE.CONTRACTORS_LIST.SELECTED_CONTRACTOR_ITEM).addClass('d-block').removeClass('d-none');
		}
		else {
			$(INVOICE.CONTRACTORS_LIST.SELECTED_CONTRACTOR_ITEM).addClass('d-none').removeClass('d-block');
		}
	}

	function clearListWithContactors(){
		$(INVOICE.CONTRACTORS_LIST.LIST_CONTAINER).empty();
	}

	function setListWithContactorsSortableMode(sortableMode : boolean){
		if(sortableMode){
			$(INVOICE.CONTRACTORS_LIST.LIST_CONTAINER).addClass(INVOICE.CONTRACTORS_LIST.LIST_CONTAINER_SORTABLE_MODE.replace('.', ''));
		}
		else {
			$(INVOICE.CONTRACTORS_LIST.LIST_CONTAINER).removeClass(INVOICE.CONTRACTORS_LIST.LIST_CONTAINER_SORTABLE_MODE.replace('.', ''));
		}
	}

	function toggleVisibleEmailAndPhoneOnInvoiceForm(show: boolean) {
		if(show){
			$(INVOICE.SPECIAL_INVOICE_FIELDS_CONTAINER).addClass('d-block').removeClass('d-none');
		}
		else{
			$(INVOICE.SPECIAL_INVOICE_FIELDS_CONTAINER).addClass('d-none').removeClass('d-block');
		}
	}

	function toggleWrongInvoiceDataBtn(show: boolean){
		if(show){
			$(INVOICE.SUBSECTION_INCORRECT_CONTRACTOR_DATA).addClass('d-block').removeClass('d-none');
		}
		else{
			$(INVOICE.SUBSECTION_INCORRECT_CONTRACTOR_DATA).addClass('d-none').removeClass('d-block');
		}
	}

	function toggleVisibleSubsectionCopyDataFromDeliveryToInvoice(show: boolean){
		if(show){
			$(INVOICE.SUBSECTION_COPY_DATA_FROM_DELIVERY_TO_INVOICE).addClass('d-block').removeClass('d-none');
		}
		else{
			$(INVOICE.SUBSECTION_COPY_DATA_FROM_DELIVERY_TO_INVOICE).addClass('d-none').removeClass('d-block');
		}
	}

	function toggleSelectedContractorItem(){
		toggleVisibleContractorsList(null);
		toggleVisibleContractorsListSelectedItem(false);
	}

	function setContractorToListHeader(data: Contractor){
		let firstLine = data.NIP;
		let secondLine = '';
		if(!empty(data.ULICA)){
			secondLine += data.ULICA;
		}
		if(!empty(data.NR_DOMU)){
			secondLine += ' ' + data.NR_DOMU;
		}
		if(!empty(data.NR_LOKALU)){
			secondLine += '/' + data.NR_LOKALU;
		}
		secondLine += ', ' + data.KOD_POCZTOWY + ' ' + data.MIEJSCOWOSC;
		secondLine.trim();

		$(INVOICE.CONTRACTORS_LIST.SELECTED_CONTRACTOR_ITEM_TEXT_FIRST_ROW).text(firstLine);
		$(INVOICE.CONTRACTORS_LIST.SELECTED_CONTRACTOR_ITEM_TEXT_SECOND_ROW).text(secondLine);
	}

	function toggleRequiredAndStartsOnInvoiceFormFields(required: boolean){
		$(INVOICE.FORM_FIELDS_LABEL_STAR).addClass('d-none').removeClass('d-inline-block');

		Object.entries([
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_NAME,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_CITY,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_POSTAL_CODE,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_STREET,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_HNUMBER,
			INVOICE.FORM_FIELDS.INVOICE_EMAIL,
			INVOICE.FORM_FIELDS.INVOICE_PHONE,
		]).forEach(([key, value]) => {
			const inputElement = $(value);
			const labelElement = inputElement.closest('.form-group').find('label');
			const labelStar = labelElement.find('span.label-star');
			inputElement.prop('required', required);
			if(required){
				labelStar.addClass('d-inline-block').removeClass('d-none');
			}
			else{
				labelStar.addClass('d-none').removeClass('d-inline-block');
			}
		});
	}

	function prepareListWithContractors(data: Contractor[])
	{
		let template = $(INVOICE.CONTRACTORS_LIST.TEMPLATE_ELEMENT).html();
		data.forEach(function(Contractor) {
			let tmpTemplate = $(template);
			let secondLine = '';
			if(!empty(Contractor.ULICA)){
				secondLine += Contractor.ULICA;
			}
			if(!empty(Contractor.NR_DOMU)){
				secondLine += ' ' + Contractor.NR_DOMU;
			}
			if(!empty(Contractor.NR_LOKALU)){
				secondLine += '/' + Contractor.NR_LOKALU;
			}
			secondLine += ', ' + Contractor.KOD_POCZTOWY + ' ' + Contractor.MIEJSCOWOSC;
			secondLine.trim();

			tmpTemplate.find(INVOICE.CONTRACTORS_LIST.SINGLE_CONTRACTOR_RADIO_BUTTON)
				.val(Contractor.NUMER_KONTRAHENTA)
				.attr("data-nip", Contractor.NIP)
				.attr("data-company-name", Contractor.NAZWA_PELNA)
				.attr("data-city", Contractor.MIEJSCOWOSC)
				.attr("data-postal-code", Contractor.KOD_POCZTOWY)
				.attr("data-street", Contractor.ULICA)
				.attr("data-fnumber", Contractor.NR_DOMU)
				.attr("data-lnumber", Contractor.NR_LOKALU);
			tmpTemplate.find(INVOICE.CONTRACTORS_LIST.SINGLE_CONTRACTOR_TEXT_FIRST_LINE).text(Contractor.NIP);
			tmpTemplate.find(INVOICE.CONTRACTORS_LIST.SINGLE_CONTRACTOR_TEXT_SECOND_LINE).text(secondLine);
			$(INVOICE.CONTRACTORS_LIST.LIST_CONTAINER).append(tmpTemplate);
		});
	}

	async function ajaxGetContractorDataByNip(nip : string): Promise<{ status: 'success' | 'failed', data: Contractor[] }> {
		const url = `/${getCurrentLanguage}/a_cart/find_contractor_by_nip/`;
		let formData = new FormData();
		formData.append('nip', nip);
		let response = await fetch(url, {
			method: 'POST',
			body: formData
		});
		let responseData: Contractor[] = await response.json();
		if (response.ok) {
			return {
				status: 'success',
				data: responseData
			}
		} else {
			return {
				status: 'failed',
				data: undefined
			}
		}
	}

	function reportIncorrectContractorData(event)
	{
		event.preventDefault();
		let dynamicForm = $('<form>', {
			method: 'POST',
			action:  `/${getCurrentLanguage}/report_wrong_contractor_data/`
		});

		Object.entries([
			INVOICE.FIELD_NIP,
			INVOICE.FORM_FIELDS.INVOICE_CONTRACTOR_NUMBER,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_NAME,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_CITY,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_POSTAL_CODE,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_STREET,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_HNUMBER,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_LNUMBER,
		]).forEach(([key, fieldId]) => {
			let fieldValue = $(fieldId).val();
			dynamicForm.append($('<input>', {
				type: 'hidden',
				name: fieldId.replace('#', ''),
				value: fieldValue
			}));
		});
		$('body').append(dynamicForm);
		dynamicForm.submit();
	};

	function actionStep2CreateNewAccountAndContinue(event){
		event.preventDefault();
		let createAccountInsideCartFormValidation = new CreateAccountInsideCartFormValidation();
		if(createAccountInsideCartFormValidation.validate()){
			$(COMMON.WANT_NEW_ACCOUNT_CHECKBOX).prop('checked', true);
			$(COMMON.SECRET_FIELD_NEW_PASSWORD).val($(COMMON.CREATE_NEW_ACCOUNT_PASSWORD).val());
			submitForm();
		} else {
			return false;
		}
	}

    function copingDeliveryData() {
        //CART STEP 2 COPYING DELIVERY DATA
        let $a = $(`${DELIVERY_FORM_FIELDS.CART_SAVED_DELIVERY} option:selected`);
        $(DELIVERY_FORM_FIELDS.DELIVERY_FIRST_NAME).val($a.data('first_name'));
        $(DELIVERY_FORM_FIELDS.DELIVERY_LAST_NAME).val($a.data('last_name'));
        $(DELIVERY_FORM_FIELDS.DELIVERY_STREET).val($a.data('street'));
        $(DELIVERY_FORM_FIELDS.DELIVERY_HNUMBER).val($a.data('hnumber'));
        $(DELIVERY_FORM_FIELDS.DELIVERY_LNUMBER).val($a.data('lnumber'));
        $(DELIVERY_FORM_FIELDS.DELIVERY_POSTAL).val($a.data('postal'));
        $(DELIVERY_FORM_FIELDS.DELIVERY_CITY).val($a.data('city'));
        $(DELIVERY_FORM_FIELDS.DELIVERY_PHONE).val($a.data('phone'));
    }

	/**
	 * Open new window with CA calculator
	 *
	 * @param e
	 */
	function creditAgricoleInitCalculatorOnTheBasket(e: JQueryEventObject)
	{
		e.preventDefault();
		let url = $(e.currentTarget).attr('data-window-target');
		let bskPrice = $(COMMON.SUMMARY_BASKET_PRICE).attr('data-summary-delivery-price');
		url = url.replace('{{AMOUNT}}', bskPrice);
		let width = 800;
		let height = 600;
		let options = `width=${width},height=${height},resizable=yes,scrollbars=yes`;
		window.open(url, '_blank', options);
	}

    // $body.ready(checkIfAnotherDeliveryMethodShouldBeBlocked);
    $body.on('ready', PaymentInput, () => CartCalc.calcDelivery());
    $body.on('ready', DeliveryInput, () => CartCalc.calcDelivery());
    $body.on('submit', COMMON.FORM, () => CartCalc.checkPaymentAndDelivery);

	$body.on('change', COMMON.FORM, async () => {
		await CartCalc.calcDelivery();
		await toggleCreditAgricolePaymentMethod();
	});

    $body.on('change', DELIVERY_FORM_FIELDS.CART_SAVED_DELIVERY, copingDeliveryData);
    $body.on('change', COMMON.SELECTED_DELIVERY_RADIO, showDepartmentModal);

    $body.on('click', COMMON.LOGIN_WHEN_USER_IS_GUEST_BTN, submitModalForm);
    $body.on('click', DEPARTMENTS.CHANGE_BTN, showDepartmentModal);
    $body.on('click', DEPARTMENTS.SUBMIT_BTN, submitDepartmentForm);
    $body.on('click', DEPARTMENTS.MAP_VOIVODESHIP, changeMapVoivodeship);
    $body.on('click', DEPARTMENTS.MAP_VOIVODESHIP_LIST_ELEM, clickMapVoivodeshipListElement);
    $body.on('click', COMMON.LAST_STEP_BTN, checkIfGuestExistsAndShowModalIfYes);
    $body.on('click', COMMON.LAST_STEP_BTN_FINAL, submitForm);
    $body.on('click', COMMON.DELIVERY_TILE_SALON, changePaymentMethodToPrzelewy);
    $body.on('click', COMMON.CONTINUE_AS_GUEST_BTN, submitForm);
	$body.on('change', COMMON.SELECTED_PAYMENT_RADIO, toggleCreditAgricoleExtraInfo);
	$body.on('change', COMMON.SELECTED_PAYMENT_RADIO, paymentMethodChanges);
	$body.on('click', COMMON.CREDIT_PAYMENT_MODAL_BTN_ACCEPT, acceptCreditPaymentMethodFullCost);
//     $body.on('change', COMMON.PAYMENT_METHOD_ERATY, showCreditBankModal);
    $body.on('change', COMMON.WANT_ANOTHER_DELIVERY_ADRESS_CHECKBOX, toggleAnotherDeliveryAddressFormVisibility);

    $body.on('change', `${COMMON.WANT_INVOICE_CHECKBOX}`, toggleInvoiceDataVisibility);
	$body.on('click' , COMMON.BTN_CREATE_NEW_ACCOUNT_AND_CONTINUE, actionStep2CreateNewAccountAndContinue)

	$body.on('click', INVOICE.BTN_SEARCH_CONTRACTOR, searchContractorAndPrepareForm)
	$body.on('click', INVOICE.CONTRACTORS_LIST.SINGLE_CONTRACTOR_RADIO_BUTTON, selectSingleContractorFromList)
	$body.on('click', INVOICE.BTN_REPORT_INCORRECT_CONTRACTOR_DATA, reportIncorrectContractorData)
	$body.on('click', INVOICE.CONTRACTORS_LIST.SELECTED_CONTRACTOR_ITEM_BTN, toggleSelectedContractorItem)

    /**
     * @warning Don't change this callback function to arrow function. Otherwise this callback will receive undefined instead of button
     * @description This method applies 1 function for 2 data forms */
    $body.on('click', `${COMMON.COPY_INVOICE_BTN}, ${COMMON.COPY_ANOTHER_DELIVERY_ADRESSES_BTN}`, function () {
        copyDeliveryDataToForm(this)
    });

	/**
	 * CA calculator on step2
	 */
	$body.on('click', COMMON.CREDIT_AGRICOLE_CALCULATOR_BTN, creditAgricoleInitCalculatorOnTheBasket);


    $body.on('select2:select', DEPARTMENTS.MODAL_SELECT, changeDepartmentSelect);

    return true;
})();

export {GuestModal}
import * as $ from "jquery";
import {$body} from 'Core/Body';
import {getCurrentLanguage} from 'Core/Languages';
import {Notifications} from 'Core/Notifications';
import {setFormSerialized} from 'Components/Cart/GuestModal';
import {setEmail} from 'Components/Cart/GuestModal';
import {GuestModal} from 'Components/Cart/GuestModal';
import {CartCalc} from 'Components/Cart/CartCalc';
import {Step2Selectors} from 'Components/Cart/Step2/Step2Selectors';
import "bootstrap/js/src/modal";
import * as select2 from "select2";

import Step2FormValidation from "Components/Validation/Step2FormValidation";
import CreateAccountInsideCartFormValidation from "Components/Validation/CreateAccountInsideCartFormValidation";
import {Contractor, RandProductsResponse} from "Components/Cart/types";
import {isNipPl} from "../../../Functions/isNipPl";
import LoginFields from "Components/Fields/LoginFields";
const empty = require('is-empty');

export const Step2Component = (() => {
    // @ts-ignore - HACK: types mismatch the module resolution. We need to actually init select2 this way in order to be able to call $().select2() later
    select2();

    const {
        COMMON, DELIVERY_FORM_FIELDS,
        FORM_FIELDS_ERROR, DEPARTMENTS, INVOICE
    } = Step2Selectors;

    const DeliveryInput = $(COMMON.DELIVERY).find('input');
    const PaymentInput = $(COMMON.PAYMENT).find('input');
    const CollectionInPersonDeliveryMethodID: number = 19;
    const lang: string = getCurrentLanguage;

	//this variable stores information about whether the currently selected payment method is a credit
	let isSelectCreditPaymentMethod = false;

    function showGuestModal() {
        $(COMMON.GUEST_MODAL).modal("show");
        $(COMMON.ALLOW_GUEST_CHECKER).val("true");
        $("select").select2();
    }

	function showNewAccountModal(){
		$(COMMON.NEW_ACCOUNT_MODAL).modal("show");
	}

    function showDepartmentModal() {
        $(DEPARTMENTS.MODAL_SELECT).select2({
            dropdownParent: $("#DepartmentsModal")
        });
        if ($(COMMON.SELECTED_DELIVERY_RADIO).val() == 19) {
            $(DEPARTMENTS.MODAL).modal("show");
            $(DEPARTMENTS.ADDRESS_DIV).show();
            $(DEPARTMENTS.ID_INPUT).data('rule-required', true);
        } else  {
            $(DEPARTMENTS.ADDRESS_DIV).hide();
            $(DEPARTMENTS.ID_INPUT).val('');
            $(DEPARTMENTS.ID_INPUT).data('rule-required', false);
            $(DEPARTMENTS.ADDRESS).html('Brak salonu');
        }
    }

    function changeMapVoivodeship(event) {
        event.preventDefault();
        let $voivodeshipName = $(this).data('map-voivodeship');
        changeDepartmentVoivodeship($voivodeshipName);
    }

    function clickMapVoivodeshipListElement() {
        let $idDepartment = $(this).data('id-department');
        let $voivodeshipName = $(this).closest('.element-voivodeship').data('voivodeship');
        changeDepartmentVoivodeship($voivodeshipName);

        $(DEPARTMENTS.MAP_VOIVODESHIP_LIST_ELEM).removeClass('active');
        $(this).addClass('active');

        $(DEPARTMENTS.MODAL_SELECT).val($idDepartment).trigger('change');
    }

    function changeDepartmentSelect() {
        let $idDepartment = $(this).val();
        let $voivodeshipName = $(DEPARTMENTS.MAP_VOIVODESHIP_LIST).find("div[data-id-department='" + $idDepartment + "']").closest('.element-voivodeship').data('voivodeship');
        changeDepartmentVoivodeship($voivodeshipName);

        $(DEPARTMENTS.MAP_VOIVODESHIP_LIST_ELEM).removeClass('active');
        $(DEPARTMENTS.MAP_VOIVODESHIP_LIST).find('div[data-id-department="' + $idDepartment + '"]').addClass('active');

        $(DEPARTMENTS.MODAL_SELECT).val($idDepartment).trigger('change');
    }

    function changeDepartmentVoivodeship($voivodeshipName) {
        $(DEPARTMENTS.MAP_VOIVODESHIP).removeClass('active');
        $(DEPARTMENTS.MAP_VOIVODESHIP).find('path').removeClass('active');

        $(DEPARTMENTS.MAP_VOIVODESHIP + '[data-map-voivodeship=' + $voivodeshipName + ']').addClass('active');
        $(DEPARTMENTS.MAP_VOIVODESHIP + '[data-map-voivodeship=' + $voivodeshipName + ']').find('path').addClass('active');

        $(DEPARTMENTS.MAP_VOIVODESHIP_LIST).find("div[data-voivodeship!='" + $voivodeshipName + "']").hide();
        $(DEPARTMENTS.MAP_VOIVODESHIP_LIST).find("div[data-voivodeship='" + $voivodeshipName + "']").show();

        $(DEPARTMENTS.MAP_VOIVODESHIP_LIST).find("div[data-voivodeship!='" + $voivodeshipName + "'] div").hide();
        $(DEPARTMENTS.MAP_VOIVODESHIP_LIST).find("div[data-voivodeship='" + $voivodeshipName + "'] div").show();

        $('#department-map-list').find('#info-before-select').hide();
    }

    function submitModalForm(event) {
        event.preventDefault();
        const lang = getCurrentLanguage;
        let $redirectUrl = $(COMMON.MODAL_FORM).find('#login_redirect_url').val();

        $.post(`/${lang}/login/sign-in/?check=1`, $(COMMON.MODAL_FORM).serialize(), (res) => {
            const json = JSON.parse(res);
            if (json.status === "success") {
                window.location.replace($redirectUrl.toString());
            } else {
                Notifications.add('Hasło jest nieprawidłowe', 'error');
            }
        });
        return false;
    }

    function submitDepartmentForm(event) {
        event.preventDefault();

        const $idDepartment = $(DEPARTMENTS.MODAL_SELECT).find('option:selected').val();
        const $addressDepartment = $(DEPARTMENTS.MODAL_SELECT).find('option:selected').text();

        $(DEPARTMENTS.MODAL).modal("hide");
        if ($idDepartment) {
            $(DEPARTMENTS.ADDRESS_DIV).show();
            $(FORM_FIELDS_ERROR.ID_INPUT).css({"display": "none"});
            $(DEPARTMENTS.ADDRESS).html($addressDepartment);
            $(DEPARTMENTS.ID_INPUT).val($idDepartment);
            $(DEPARTMENTS.ADDRESS_DIV).removeClass('is-invalid');
            $(DEPARTMENTS.ADDRESS_DIV_ERROR_VALIDATE).css({"display": "none"});
        } else {
            $(FORM_FIELDS_ERROR.ID_INPUT).css({"display": "block"});
            $(DEPARTMENTS.ADDRESS).html('Brak salonu');
            $(DEPARTMENTS.ID_INPUT).val('');
        }
    }

    function checkIfGuestExistsAndShowModalIfYes(e: JQueryEventObject) {
        e.preventDefault()
		let step2FormValidation = new Step2FormValidation();
		if(step2FormValidation.validate() ) {

			const email = $(COMMON.DELIVERY_EMAIL_INPUT).val() as string;
			const FormSerialized = $(COMMON.FORM).serialize();
			let isSetWantNewAccount = $(COMMON.WANT_NEW_ACCOUNT_CHECKBOX).prop('checked');

			if (email.trim()) {
				$.get(`/${lang}/cart/checkIfGuestAlreadyExists/${email}`, function (data) {
					if(data === 'NOT EXIST' && !isSetWantNewAccount){
						showNewAccountModal();
					}
					else if (data === 'EXIST' && $(COMMON.ALLOW_GUEST_CHECKER).val() != 'true') {
						setEmail(email, COMMON.MODAL_EMAIL);
						setFormSerialized(FormSerialized, COMMON.MODAL_FORM_SERIALIZED);
						showGuestModal();
					}
					else {
						submitForm();
					}
				});
			} else {
				submitForm();
			}

		}
    }

    function submitForm() {
        let step2FormValidation = new Step2FormValidation();
        if(step2FormValidation.validate() ){
            $(COMMON.LAST_STEP_BTN).prop('disabled', true);
            $(COMMON.LAST_STEP_BTN_FINAL).prop('disabled', true);
            $(COMMON.LIGHT_PRELOADER).removeClass('d-none');
            $(COMMON.FORM).submit();
        }else{
            Notifications.add(`Wystąpił błąd w wysyłaniu formularza`, 'error');
        }
    }

    function copyDeliveryDataToForm(clickedButton) {
        let formToApplyFields: string;
        let fields: string[];

        $(clickedButton).attr('id') == $(COMMON.COPY_INVOICE_BTN).attr('id')
            ? formToApplyFields = 'invoice'
            : formToApplyFields = 'another_delivery';

        formToApplyFields == 'invoice'
            ? fields = ['street', 'hnumber', 'lnumber', 'postal', 'city', 'email', 'phone']
            : fields = ['first_name', 'last_name', 'street', 'hnumber', 'lnumber', 'postal', 'city', 'phone', 'email'];


        fields.forEach(field => $(`#${formToApplyFields}_${field}`).val($(`#delivery_${field}`).val()));
    }

    function toggleInvoiceDataVisibility(e) {
        e.preventDefault();
        let wantInvoice = $(COMMON.WANT_INVOICE_CHECKBOX).prop('checked');
        if(wantInvoice){
			$(INVOICE.SECTION).addClass('d-block').removeClass('d-none');
        } else {
            $(INVOICE.SECTION).addClass('d-none').removeClass('d-block');
        }

		togglePaymentMethodBlock();
		toggleCreditAgricolePaymentMethod();
    }

    function toggleAnotherDeliveryAddressFormVisibility(e) {
        e.preventDefault();
        $(COMMON.ANOTHER_DELIVERY_ADDRESS_DATA).toggle();
        toggleDeliveryMethodBlock();
    }


    function checkIfAnotherDeliveryMethodShouldBeBlocked() {
        // Check if CollectionInPerson is the only one available delivery method: if yes => block another delivery methods checkbox
        // @ts-ignore
        const blocked: boolean = $(COMMON.DELIVERY_RADIO).length == 1 && parseInt($(COMMON.DELIVERY_RADIO).val()) == CollectionInPersonDeliveryMethodID;

        if (blocked) {
            $(COMMON.WANT_ANOTHER_DELIVERY_ADRESS_CHECKBOX).prop('disabled', true);
            $(COMMON.DELIVERY_TILE).removeClass('method-locked');
            $(COMMON.DELIVERY_RADIO).prop('checked', 'checked');
        }
    }

    function toggleDeliveryMethodBlock() {
        // Check if CollectionInPerson is the only one available delivery method
        // @ts-ignore
        if ($(COMMON.DELIVERY_TILE_SALON).hasClass('method-locked')) {
            $(COMMON.DELIVERY_TILE_SALON).removeClass('method-locked');
        } else {
            $(COMMON.DELIVERY_TILE_SALON).addClass('method-locked');
            $(COMMON.DELIVERY_RADIO_SALON).prop('checked', false);
            $(COMMON.DELIVERY_RADIO_KURIER).prop('checked', true);
            $(DEPARTMENTS.ADDRESS_DIV).css("display", "none");
        }
	}

	/**
	 * I collect all the conditions for enabling / disabling Credit Agricole payments
	 */
	function isCreditAgricolePaymentLocks() : boolean
	{
		let wantInvoice = $(COMMON.WANT_INVOICE_CHECKBOX).prop('checked');
		let bskProdsAndDeliveryPrice = $(COMMON.SUMMARY_BASKET_PRICE).attr('data-summary-delivery-price');
		let toSmallAmountInTheBasket = (parseFloat(bskProdsAndDeliveryPrice) < parseFloat($(COMMON.PAYMENT_METHOD_CREDIT_AGRICOLE_LOAN_0_20).data('minimum-order-amount')));
		// I'm moving all the conditions to one table
		let boolArray = [wantInvoice, toSmallAmountInTheBasket];
		// Reduces all logical OR conditions to one variable
		return  boolArray.reduce((acc, current) => acc || current, false);
	}

	/**
	 * Full information switching on credit agricole payments
	 */
	function toggleCreditAgricolePaymentMethod()
	{
		let turnOnCreditAgricolePaymentLock = isCreditAgricolePaymentLocks();
		if (turnOnCreditAgricolePaymentLock) {
			$(COMMON.PAYMENT_TILE_CREDIT_AGRICOLE_LOAN_3_0_10).addClass('method-locked');
			$(COMMON.PAYMENT_TILE_CREDIT_AGRICOLE_LOAN_0_20).addClass('method-locked');
			$(COMMON.PAYMENT_METHOD_CREDIT_AGRICOLE_LOAN_3_0_10).prop('checked', false);
			$(COMMON.PAYMENT_METHOD_CREDIT_AGRICOLE_LOAN_0_20).prop('checked', false);
		}else{
			$(COMMON.PAYMENT_TILE_CREDIT_AGRICOLE_LOAN_3_0_10).removeClass('method-locked').removeClass('method-locked-system');
			$(COMMON.PAYMENT_TILE_CREDIT_AGRICOLE_LOAN_0_20).removeClass('method-locked').removeClass('method-locked-system');
		}

		toggleCreditAgricoleErrorOnInvoice();
		toggleCreditAgricoleExtraInfo();
		togglePaymentMethodCreditAgricoleTexts();
	}

	function togglePaymentMethodCreditAgricoleTexts(){
		[COMMON.PAYMENT_TILE_CREDIT_AGRICOLE_LOAN_3_0_10, COMMON.PAYMENT_TILE_CREDIT_AGRICOLE_LOAN_0_20].forEach( (paymentBlock) => {
			if($(paymentBlock).is(".method-locked, .method-locked-system")){
				$(paymentBlock).find(COMMON.CREDIT_AGRICOLE_PAYMENT_TEXT_AVAILABLE).addClass('d-none').removeClass('d-inline');
				$(paymentBlock).find(COMMON.CREDIT_AGRICOLE_PAYMENT_TEXT_UNAVAILABLE).addClass('d-inline').removeClass('d-none');
			}else{
				$(paymentBlock).find(COMMON.CREDIT_AGRICOLE_PAYMENT_TEXT_AVAILABLE).addClass('d-inline').removeClass('d-none')
				$(paymentBlock).find(COMMON.CREDIT_AGRICOLE_PAYMENT_TEXT_UNAVAILABLE).addClass('d-none').removeClass('d-inline');
			}
		});
	}

	function toggleCreditAgricoleErrorOnInvoice(){
		let wantInvoice = $(COMMON.WANT_INVOICE_CHECKBOX).prop('checked');
		if(wantInvoice){
			$(COMMON.PAYMENT_ERROR_CREDIT_AGRICOLE_INVOICE).addClass('d-block').removeClass('d-none');
		}else{
			$(COMMON.PAYMENT_ERROR_CREDIT_AGRICOLE_INVOICE).addClass('d-none').removeClass('d-block');
		}
	}

	function toggleCreditAgricoleExtraInfo()
	{
		let isPaymentCreditAgricole = false;
		[COMMON.PAYMENT_METHOD_CREDIT_AGRICOLE_LOAN_3_0_10, COMMON.PAYMENT_METHOD_CREDIT_AGRICOLE_LOAN_0_20].forEach( (paymentRadioButton) => {
			if($(paymentRadioButton).prop("checked") == true) {
				isPaymentCreditAgricole = true;
			}
		});

		if(isPaymentCreditAgricole){
			$(COMMON.PAYMENT_INFO_CREDIT_AGRICOLE_WARNING).addClass('d-block').removeClass('d-none');
			$(COMMON.PAYMENT_INFO_CREDIT_AGRICOLE_LINK_PDF).addClass('d-block').removeClass('d-none');
		} else {
			$(COMMON.PAYMENT_INFO_CREDIT_AGRICOLE_WARNING).addClass('d-none').removeClass('d-block');
			$(COMMON.PAYMENT_INFO_CREDIT_AGRICOLE_LINK_PDF).addClass('d-none').removeClass('d-block');
		}
	}

	function togglePaymentMethodBlock() {
        if ($(COMMON.PAYMENT_TILE_COD).hasClass('method-locked')) {
            $(COMMON.PAYMENT_TILE_COD).removeClass('method-locked');
        } else {
            $(COMMON.PAYMENT_TILE_COD).addClass('method-locked');
            $(COMMON.PAYMENT_METHOD_COD).prop('checked', false);
            $(COMMON.PAYMENT_METHOD_PRZELEWY).prop('checked', true);
        }

        if ($(COMMON.PAYMENT_TILE_ERATY).hasClass('method-locked')) {
            $(COMMON.PAYMENT_TILE_ERATY).removeClass('method-locked');
        } else {
            $(COMMON.PAYMENT_TILE_ERATY).addClass('method-locked');
            $(COMMON.PAYMENT_METHOD_ERATY).prop('checked', false);
            $(COMMON.PAYMENT_METHOD_PRZELEWY).prop('checked', true);
        }
    }

    function changePaymentMethodToPrzelewy() {
        $(COMMON.PAYMENT_METHOD_PRZELEWY).prop('checked', true);
    }

	function paymentMethodChanges(){
		let isNowSelectedCreditPaymentMethod = $(COMMON.SELECTED_PAYMENT_RADIO).hasClass(COMMON.DELIVERY_RADIO_IS_CREDIT);

		let cartThresholdIsdActive = $(COMMON.CART_THRESHOLD.INPUT_IS_ACTIVE).val() === 'true';
		let cartThresholdIsFirstThresholdIsCrossed = $(COMMON.CART_THRESHOLD.INPUT_IS_FIRST_THRESHOLD_CROSSED).val() === 'true';

		if(cartThresholdIsdActive && cartThresholdIsFirstThresholdIsCrossed){
			if(isSelectCreditPaymentMethod == false && isNowSelectedCreditPaymentMethod == true){
				showCreditBankModal();
			}
		}

		isSelectCreditPaymentMethod = isNowSelectedCreditPaymentMethod;
	}

    function showCreditBankModal() {
		$(COMMON.CREDIT_PAYMENT_MODAL).modal({
			backdrop: 'static',
			keyboard: false
		});
    }

    function acceptCreditPaymentMethodFullCost() {
    	$(COMMON.CREDIT_PAYMENT_MODAL).modal("hide");
    }
	async function searchContractorAndPrepareForm(event) {
		let btn = event.currentTarget;
		btn.disabled = true;
		let nip = $(INVOICE.FIELD_NIP).val().toString();
		$(INVOICE.FIELD_NIP).attr('data-value', nip);

		let nextStepBtn = $(COMMON.LAST_STEP_BTN);
		nextStepBtn.prop('disabled', true);

		if(!isNipPl(nip)){
			$(INVOICE.FIELD_NIP).addClass('is-invalid');
			let formGroup = $(INVOICE.FIELD_NIP).closest('.form-group');
			let invalidFeedback = formGroup.find('.invalid-feedback');
			if (invalidFeedback.length > 0 && invalidFeedback.is(':visible')) {
				//do nothing - some error is already displayed
			} else {
				$(INVOICE.FIELD_NIP_ERROR).removeClass('d-none').addClass('d-block').text('Numer NIP jest niepoprawny ');
			}

			btn.disabled = false;
			nextStepBtn.prop('disabled', false);
			return;
		} else {
			$(INVOICE.FIELD_NIP).removeClass('is-invalid');
			$(INVOICE.FIELD_NIP_ERROR).removeClass('d-block').addClass('d-none').text('');
		}

		let erpData = await ajaxGetContractorDataByNip(nip);
		let countData = erpData.data.length;
		btn.disabled = false;
		nextStepBtn.prop('disabled', false);

		clearInvoiceForm();
		clearListWithContactors();
		toggleWrongInvoiceDataBtn(false);
		toggleVisibleContractorsListSelectedItem(false);
		toggleVisibleSubsectionCopyDataFromDeliveryToInvoice(false);

		if (countData == 0) {
			//scenario - no contractor
			toggleVisibleEmailAndPhoneOnInvoiceForm(true);
			toggleReadonlyOnInvoiceFormFields(false);
			toggleRequiredAndStartsOnInvoiceFormFields(true);
			toggleVisibleSubsectionCopyDataFromDeliveryToInvoice(true);

			toggleVisibleInvoiceForm(true);
			toggleVisibleContractorsList(false);

		}
		else if (countData == 1) {
			//scenario - only one contactor
			toggleVisibleEmailAndPhoneOnInvoiceForm(false);
			toggleReadonlyOnInvoiceFormFields(true);
			toggleRequiredAndStartsOnInvoiceFormFields(false);
			toggleWrongInvoiceDataBtn(true);

			setContractorToInvoiceForm(erpData.data[0]);
			toggleVisibleInvoiceForm(true);
			toggleVisibleContractorsList(false)
		}
		else {
			//scenario - multiple contactors
			toggleVisibleEmailAndPhoneOnInvoiceForm(false);
			toggleReadonlyOnInvoiceFormFields(true);
			toggleRequiredAndStartsOnInvoiceFormFields(false);
			toggleWrongInvoiceDataBtn(true);

			setListWithContactorsSortableMode(countData >= 5);
			prepareListWithContractors(erpData.data)
			toggleVisibleContractorsList(true);
		}
	}

	function clearInvoiceForm(){
		Object.entries(INVOICE.FORM_FIELDS).forEach(([key, value]) => {
			$(value).val('');
		});
	}

	function toggleReadonlyOnInvoiceFormFields(readonly: boolean){
		Object.entries(INVOICE.FORM_FIELDS).forEach(([key, value]) => {
			$(value).prop('readonly', readonly);
		});
	}

	function setContractorToInvoiceForm(data: Contractor){
		$(INVOICE.FORM_FIELDS.INVOICE_COMPANY_NAME).val(data.NAZWA_PELNA);
		$(INVOICE.FORM_FIELDS.INVOICE_COMPANY_STREET).val(data.ULICA);
		$(INVOICE.FORM_FIELDS.INVOICE_COMPANY_HNUMBER).val(data.NR_DOMU);
		$(INVOICE.FORM_FIELDS.INVOICE_COMPANY_LNUMBER).val(data.NR_LOKALU);
		$(INVOICE.FORM_FIELDS.INVOICE_COMPANY_POSTAL_CODE).val(data.KOD_POCZTOWY);
		$(INVOICE.FORM_FIELDS.INVOICE_COMPANY_CITY).val(data.MIEJSCOWOSC);
		$(INVOICE.FORM_FIELDS.INVOICE_CONTRACTOR_NUMBER).val(data.NUMER_KONTRAHENTA);
	}

	function selectSingleContractorFromList(event){
		let btn = event.currentTarget;

		const contractor: Contractor = {
			NUMER_KONTRAHENTA: $(this).val() as string,
			NIP: $(this).data('nip'),
			NAZWA_PELNA: $(this).data('company-name'),
			MIEJSCOWOSC: $(this).data('city'),
			KOD_POCZTOWY: $(this).data('postal-code'),
			ULICA: $(this).data('street'),
			NR_DOMU: $(this).data('fnumber'),
			NR_LOKALU: $(this).data('lnumber')
		};

		setContractorToInvoiceForm(contractor);
		setContractorToListHeader(contractor);
		toggleVisibleInvoiceForm(true);
		toggleVisibleContractorsListSelectedItem(true);
		toggleVisibleContractorsList(false);

		Object.entries([
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_NAME,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_CITY,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_POSTAL_CODE,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_STREET,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_HNUMBER,
			INVOICE.FORM_FIELDS.INVOICE_EMAIL,
			INVOICE.FORM_FIELDS.INVOICE_PHONE,
		]).forEach(([key, value]) => {
			let inputElement = $(value).removeClass("is-invalid");
			let validatorErrorElement = inputElement.closest('.form-group').find('.invalid-feedback').remove();
		});
	}

	function toggleVisibleInvoiceForm(show : boolean){
		if(show){
			$(INVOICE.FORM_SECTION).addClass('d-flex').removeClass('d-none');
		}
		else {
			$(INVOICE.FORM_SECTION).addClass('d-none').removeClass('d-flex');
		}
	}

	function toggleVisibleContractorsList(show: boolean | null) {
		const $section = $(INVOICE.CONTRACTORS_LIST.SECTION);

		if (show === null) {
			// If the show parameter is null, check the classes
			if ($section.hasClass('d-block')) {
				$section.addClass('d-none').removeClass('d-block');
			} else {
				$section.addClass('d-block').removeClass('d-none');
			}
		} else {
			// If show is true or false, act on its value
			if (show) {
				$section.addClass('d-block').removeClass('d-none');
			} else {
				$section.addClass('d-none').removeClass('d-block');
			}
		}
	}

	function toggleVisibleContractorsListSelectedItem(show : boolean){
		if(show){
			$(INVOICE.CONTRACTORS_LIST.SELECTED_CONTRACTOR_ITEM).addClass('d-block').removeClass('d-none');
		}
		else {
			$(INVOICE.CONTRACTORS_LIST.SELECTED_CONTRACTOR_ITEM).addClass('d-none').removeClass('d-block');
		}
	}

	function clearListWithContactors(){
		$(INVOICE.CONTRACTORS_LIST.LIST_CONTAINER).empty();
	}

	function setListWithContactorsSortableMode(sortableMode : boolean){
		if(sortableMode){
			$(INVOICE.CONTRACTORS_LIST.LIST_CONTAINER).addClass(INVOICE.CONTRACTORS_LIST.LIST_CONTAINER_SORTABLE_MODE.replace('.', ''));
		}
		else {
			$(INVOICE.CONTRACTORS_LIST.LIST_CONTAINER).removeClass(INVOICE.CONTRACTORS_LIST.LIST_CONTAINER_SORTABLE_MODE.replace('.', ''));
		}
	}

	function toggleVisibleEmailAndPhoneOnInvoiceForm(show: boolean) {
		if(show){
			$(INVOICE.SPECIAL_INVOICE_FIELDS_CONTAINER).addClass('d-block').removeClass('d-none');
		}
		else{
			$(INVOICE.SPECIAL_INVOICE_FIELDS_CONTAINER).addClass('d-none').removeClass('d-block');
		}
	}

	function toggleWrongInvoiceDataBtn(show: boolean){
		if(show){
			$(INVOICE.SUBSECTION_INCORRECT_CONTRACTOR_DATA).addClass('d-block').removeClass('d-none');
		}
		else{
			$(INVOICE.SUBSECTION_INCORRECT_CONTRACTOR_DATA).addClass('d-none').removeClass('d-block');
		}
	}

	function toggleVisibleSubsectionCopyDataFromDeliveryToInvoice(show: boolean){
		if(show){
			$(INVOICE.SUBSECTION_COPY_DATA_FROM_DELIVERY_TO_INVOICE).addClass('d-block').removeClass('d-none');
		}
		else{
			$(INVOICE.SUBSECTION_COPY_DATA_FROM_DELIVERY_TO_INVOICE).addClass('d-none').removeClass('d-block');
		}
	}

	function toggleSelectedContractorItem(){
		toggleVisibleContractorsList(null);
		toggleVisibleContractorsListSelectedItem(false);
	}

	function setContractorToListHeader(data: Contractor){
		let firstLine = data.NIP;
		let secondLine = '';
		if(!empty(data.ULICA)){
			secondLine += data.ULICA;
		}
		if(!empty(data.NR_DOMU)){
			secondLine += ' ' + data.NR_DOMU;
		}
		if(!empty(data.NR_LOKALU)){
			secondLine += '/' + data.NR_LOKALU;
		}
		secondLine += ', ' + data.KOD_POCZTOWY + ' ' + data.MIEJSCOWOSC;
		secondLine.trim();

		$(INVOICE.CONTRACTORS_LIST.SELECTED_CONTRACTOR_ITEM_TEXT_FIRST_ROW).text(firstLine);
		$(INVOICE.CONTRACTORS_LIST.SELECTED_CONTRACTOR_ITEM_TEXT_SECOND_ROW).text(secondLine);
	}

	function toggleRequiredAndStartsOnInvoiceFormFields(required: boolean){
		$(INVOICE.FORM_FIELDS_LABEL_STAR).addClass('d-none').removeClass('d-inline-block');

		Object.entries([
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_NAME,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_CITY,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_POSTAL_CODE,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_STREET,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_HNUMBER,
			INVOICE.FORM_FIELDS.INVOICE_EMAIL,
			INVOICE.FORM_FIELDS.INVOICE_PHONE,
		]).forEach(([key, value]) => {
			const inputElement = $(value);
			const labelElement = inputElement.closest('.form-group').find('label');
			const labelStar = labelElement.find('span.label-star');
			inputElement.prop('required', required);
			if(required){
				labelStar.addClass('d-inline-block').removeClass('d-none');
			}
			else{
				labelStar.addClass('d-none').removeClass('d-inline-block');
			}
		});
	}

	function prepareListWithContractors(data: Contractor[])
	{
		let template = $(INVOICE.CONTRACTORS_LIST.TEMPLATE_ELEMENT).html();
		data.forEach(function(Contractor) {
			let tmpTemplate = $(template);
			let secondLine = '';
			if(!empty(Contractor.ULICA)){
				secondLine += Contractor.ULICA;
			}
			if(!empty(Contractor.NR_DOMU)){
				secondLine += ' ' + Contractor.NR_DOMU;
			}
			if(!empty(Contractor.NR_LOKALU)){
				secondLine += '/' + Contractor.NR_LOKALU;
			}
			secondLine += ', ' + Contractor.KOD_POCZTOWY + ' ' + Contractor.MIEJSCOWOSC;
			secondLine.trim();

			tmpTemplate.find(INVOICE.CONTRACTORS_LIST.SINGLE_CONTRACTOR_RADIO_BUTTON)
				.val(Contractor.NUMER_KONTRAHENTA)
				.attr("data-nip", Contractor.NIP)
				.attr("data-company-name", Contractor.NAZWA_PELNA)
				.attr("data-city", Contractor.MIEJSCOWOSC)
				.attr("data-postal-code", Contractor.KOD_POCZTOWY)
				.attr("data-street", Contractor.ULICA)
				.attr("data-fnumber", Contractor.NR_DOMU)
				.attr("data-lnumber", Contractor.NR_LOKALU);
			tmpTemplate.find(INVOICE.CONTRACTORS_LIST.SINGLE_CONTRACTOR_TEXT_FIRST_LINE).text(Contractor.NIP);
			tmpTemplate.find(INVOICE.CONTRACTORS_LIST.SINGLE_CONTRACTOR_TEXT_SECOND_LINE).text(secondLine);
			$(INVOICE.CONTRACTORS_LIST.LIST_CONTAINER).append(tmpTemplate);
		});
	}

	async function ajaxGetContractorDataByNip(nip : string): Promise<{ status: 'success' | 'failed', data: Contractor[] }> {
		const url = `/${getCurrentLanguage}/a_cart/find_contractor_by_nip/`;
		let formData = new FormData();
		formData.append('nip', nip);
		let response = await fetch(url, {
			method: 'POST',
			body: formData
		});
		let responseData: Contractor[] = await response.json();
		if (response.ok) {
			return {
				status: 'success',
				data: responseData
			}
		} else {
			return {
				status: 'failed',
				data: undefined
			}
		}
	}

	function reportIncorrectContractorData(event)
	{
		event.preventDefault();
		let dynamicForm = $('<form>', {
			method: 'POST',
			action:  `/${getCurrentLanguage}/report_wrong_contractor_data/`
		});

		Object.entries([
			INVOICE.FIELD_NIP,
			INVOICE.FORM_FIELDS.INVOICE_CONTRACTOR_NUMBER,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_NAME,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_CITY,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_POSTAL_CODE,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_STREET,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_HNUMBER,
			INVOICE.FORM_FIELDS.INVOICE_COMPANY_LNUMBER,
		]).forEach(([key, fieldId]) => {
			let fieldValue = $(fieldId).val();
			dynamicForm.append($('<input>', {
				type: 'hidden',
				name: fieldId.replace('#', ''),
				value: fieldValue
			}));
		});
		$('body').append(dynamicForm);
		dynamicForm.submit();
	};

	function actionStep2CreateNewAccountAndContinue(event){
		event.preventDefault();
		let createAccountInsideCartFormValidation = new CreateAccountInsideCartFormValidation();
		if(createAccountInsideCartFormValidation.validate()){
			$(COMMON.WANT_NEW_ACCOUNT_CHECKBOX).prop('checked', true);
			$(COMMON.SECRET_FIELD_NEW_PASSWORD).val($(COMMON.CREATE_NEW_ACCOUNT_PASSWORD).val());
			submitForm();
		} else {
			return false;
		}
	}

    function copingDeliveryData() {
        //CART STEP 2 COPYING DELIVERY DATA
        let $a = $(`${DELIVERY_FORM_FIELDS.CART_SAVED_DELIVERY} option:selected`);
        $(DELIVERY_FORM_FIELDS.DELIVERY_FIRST_NAME).val($a.data('first_name'));
        $(DELIVERY_FORM_FIELDS.DELIVERY_LAST_NAME).val($a.data('last_name'));
        $(DELIVERY_FORM_FIELDS.DELIVERY_STREET).val($a.data('street'));
        $(DELIVERY_FORM_FIELDS.DELIVERY_HNUMBER).val($a.data('hnumber'));
        $(DELIVERY_FORM_FIELDS.DELIVERY_LNUMBER).val($a.data('lnumber'));
        $(DELIVERY_FORM_FIELDS.DELIVERY_POSTAL).val($a.data('postal'));
        $(DELIVERY_FORM_FIELDS.DELIVERY_CITY).val($a.data('city'));
        $(DELIVERY_FORM_FIELDS.DELIVERY_PHONE).val($a.data('phone'));
    }

	/**
	 * Open new window with CA calculator
	 *
	 * @param e
	 */
	function creditAgricoleInitCalculatorOnTheBasket(e: JQueryEventObject)
	{
		e.preventDefault();
		let url = $(e.currentTarget).attr('data-window-target');
		let bskPrice = $(COMMON.SUMMARY_BASKET_PRICE).attr('data-summary-delivery-price');
		url = url.replace('{{AMOUNT}}', bskPrice);
		let width = 800;
		let height = 600;
		let options = `width=${width},height=${height},resizable=yes,scrollbars=yes`;
		window.open(url, '_blank', options);
	}

    // $body.ready(checkIfAnotherDeliveryMethodShouldBeBlocked);
    $body.on('ready', PaymentInput, () => CartCalc.calcDelivery());
    $body.on('ready', DeliveryInput, () => CartCalc.calcDelivery());
    $body.on('submit', COMMON.FORM, () => CartCalc.checkPaymentAndDelivery);

	$body.on('change', COMMON.FORM, async () => {
		await CartCalc.calcDelivery();
		await toggleCreditAgricolePaymentMethod();
	});

    $body.on('change', DELIVERY_FORM_FIELDS.CART_SAVED_DELIVERY, copingDeliveryData);
    $body.on('change', COMMON.SELECTED_DELIVERY_RADIO, showDepartmentModal);

    $body.on('click', COMMON.LOGIN_WHEN_USER_IS_GUEST_BTN, submitModalForm);
    $body.on('click', DEPARTMENTS.CHANGE_BTN, showDepartmentModal);
    $body.on('click', DEPARTMENTS.SUBMIT_BTN, submitDepartmentForm);
    $body.on('click', DEPARTMENTS.MAP_VOIVODESHIP, changeMapVoivodeship);
    $body.on('click', DEPARTMENTS.MAP_VOIVODESHIP_LIST_ELEM, clickMapVoivodeshipListElement);
    $body.on('click', COMMON.LAST_STEP_BTN, checkIfGuestExistsAndShowModalIfYes);
    $body.on('click', COMMON.LAST_STEP_BTN_FINAL, submitForm);
    $body.on('click', COMMON.DELIVERY_TILE_SALON, changePaymentMethodToPrzelewy);
    $body.on('click', COMMON.CONTINUE_AS_GUEST_BTN, submitForm);
	$body.on('change', COMMON.SELECTED_PAYMENT_RADIO, toggleCreditAgricoleExtraInfo);
	$body.on('change', COMMON.SELECTED_PAYMENT_RADIO, paymentMethodChanges);
	$body.on('click', COMMON.CREDIT_PAYMENT_MODAL_BTN_ACCEPT, acceptCreditPaymentMethodFullCost);
//     $body.on('change', COMMON.PAYMENT_METHOD_ERATY, showCreditBankModal);
    $body.on('change', COMMON.WANT_ANOTHER_DELIVERY_ADRESS_CHECKBOX, toggleAnotherDeliveryAddressFormVisibility);

    $body.on('change', `${COMMON.WANT_INVOICE_CHECKBOX}`, toggleInvoiceDataVisibility);
	$body.on('click' , COMMON.BTN_CREATE_NEW_ACCOUNT_AND_CONTINUE, actionStep2CreateNewAccountAndContinue)

	$body.on('click', INVOICE.BTN_SEARCH_CONTRACTOR, searchContractorAndPrepareForm)
	$body.on('click', INVOICE.CONTRACTORS_LIST.SINGLE_CONTRACTOR_RADIO_BUTTON, selectSingleContractorFromList)
	$body.on('click', INVOICE.BTN_REPORT_INCORRECT_CONTRACTOR_DATA, reportIncorrectContractorData)
	$body.on('click', INVOICE.CONTRACTORS_LIST.SELECTED_CONTRACTOR_ITEM_BTN, toggleSelectedContractorItem)

    /**
     * @warning Don't change this callback function to arrow function. Otherwise this callback will receive undefined instead of button
     * @description This method applies 1 function for 2 data forms */
    $body.on('click', `${COMMON.COPY_INVOICE_BTN}, ${COMMON.COPY_ANOTHER_DELIVERY_ADRESSES_BTN}`, function () {
        copyDeliveryDataToForm(this)
    });

	/**
	 * CA calculator on step2
	 */
	$body.on('click', COMMON.CREDIT_AGRICOLE_CALCULATOR_BTN, creditAgricoleInitCalculatorOnTheBasket);


    $body.on('select2:select', DEPARTMENTS.MODAL_SELECT, changeDepartmentSelect);

    return true;
})();

export {GuestModal}
